@if (product) {
	<a
		class="c-product-grid-item"
		cypressTag="ProductGridItem.Link"
		[routerLink]="[
			'/',
			i18nService.currentLanguage,
			offersRoutePaths.Offers,
			offersRoutePaths.OffersDetail,
			product.id
		]"
	>
		<div class="c-product-grid-item__service-provider" [ariaHidden]="true">
			<fa-icon icon="fa-building" iconType="fa-regular" />
			<div class="c-product-grid-item__service-provider__partner-list">
				@for (partner of product.partners; track partner) {
					<div class="c-product-grid-item__service-provider__partner">
						<span
							class="c-vloket-header--subtitle c-vloket-text-marking c-vloket-text-marking--underline c-product-grid-item__service-provider_link"
							>{{ partner.name }}</span
						>
					</div>
				}
			</div>
		</div>
		<div class="c-product-grid-item__top">
			<h4 class="c-vloket-header c-vloket-header--h5 c-product-grid-item__title">{{ product.name }}</h4>
			@for (partner of product.partners; track partner) {
				<span class="cdk-visually-hidden">{{ partner.name }}</span>
			}
			<div
				class="u-limit-line--3 c-product-grid-item__rich-text"
				[innerHtml]="product.description | stripHtml: ' ' | slice: 0 : 300"
			></div>
		</div>
		<div class="c-product-grid-item__bottom">
			<cjm-tag tagType="light" icon="fa-tag" iconType="fa-solid">{{ product.type }}</cjm-tag>
		</div>
	</a>

	@if (hasFavouriteButton) {
		<vloket-primary-button
			class="c-product-grid-item--favorite-button"
			type="heart"
			[iconOnly]="true"
			[active]="product.isFavorite"
			[id]="product.id"
			[isLoading]="!!actionInProgress && actionInProgress === product.id"
			[isDisabled]="!!actionInProgress"
			(setAsPrimary)="setItemAsFavoriteClicked.emit($event)"
			(removeAsPrimary)="removeItemAsFavoriteClicked.emit($event)"
		/>
	}
}
